// @flow
import { CategoryTypes } from "../../category/misc/Types";
import * as CategoryApi from "../../category/misc/Api";
import { httpClient, isPresent } from "../../../Utilities/index";

import type { CategoryEnumT } from "../../category/misc/Types";
import type { LocationT } from "./Types";

const baseUrl = "/locations";

function getUrl(category?: CategoryEnumT) {
  switch (category) {
    case CategoryTypes.ELECTRICITY:
      return `${baseUrl}/electricity`;
    case CategoryTypes.GAS:
      return `${baseUrl}/gas`;
    default:
  }
}

type Response = {
  data: {
    locations: LocationT[],
    result: string,
  },
};

export async function getLocations(category: { id?: ?string, type?: CategoryEnumT } = {}, postCode: ?string) {
  let categoryType = category.type;
  if (!isPresent(categoryType) && isPresent(category.id)) {
    const categoryInstance = await CategoryApi.getCategory(category.id);
    categoryType = isPresent(categoryInstance) ? categoryInstance.categoryType : undefined;
  }

  const url = isPresent(categoryType) ? getUrl(categoryType) : null;
  if (!url) {
    throw new Error(
      `The category "${categoryType || category.id || "undefined"}" is not a valid category for requesting locations!`
    );
  }

  const { data }: Response = await httpClient.get(url, {
    params: { postCode },
  });

  if (data.result === "INVALID_POSTCODE") {
    throw new Error("You entered an invalid postal code");
  }

  return data.locations;
}
